// removed by extract-text-webpack-plugin
module.exports = {"Banner":"_3BJ_V1WeNxuSC0QXLYKWY3","JibberImageLogoTextBody":"_3JyraPaiB62ZArr-1ycOG3","NavBar":"_1CSQRL_HxNr65HywTrxtyj","ConversationTitle":"fk1uzjQsZuJEJGkDYPzRq","ConversationWith":"_29yAG5K0wtSuDXk2mewpKh","ConversationName":"_3IR3tfKieIKLiAX75QrkMw","MainPanelHeaderMenu":"_30-__e0wF1uHSRSFqmvBew","PreviewImage":"_26LDEAoOa0jyrJmEH_V3rD"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/Conversation/style.css
// module id = 1864
// module chunks = 0